import { useCallback } from 'react';
import { useSessao } from '../autenticacao/SessaoContexto.js';
import type { Acao } from './permissoes.js';
import { perfilPode } from './permissoes.js';

/**
 * O jeito único de a tela perguntar se o perfil da sessão pode fazer X.
 *
 * ```tsx
 * const pode = usePode();
 * {pode('dispositivos.gerenciar') && <Botao>Novo dispositivo</Botao>}
 * ```
 *
 * Enquanto a sessão não chegou (o cookie é HttpOnly, então descobrir quem
 * está logado é uma ida ao middleware), a resposta é `false` — falha fechado.
 */
export function usePode(): (acao: Acao) => boolean {
  const { estado } = useSessao();
  const perfil = estado.situacao === 'autenticado' ? estado.sessao.usuario.perfil : null;

  return useCallback((acao: Acao) => perfilPode(perfil, acao), [perfil]);
}
